import api from './utilPartner';

const controller = 'TipoDocumento';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  ListarDescricaoDocumentoPorTipo: function (dto) {
    return api.Axios.GetParams(url + '/ListarDescricaoDocumentoPorTipo', dto);
  }
});
